module.exports = __webpack_public_path__ + "images/emoji/two.86fd3b8b0a00336f7346.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/two.png
// module id = fs6A
// module chunks = 13